
import React,{useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import SearchBar from '../SearchBar';
import '../SearchBar.css'; // Make sure the styles are included
import chtypes from '../../helpers/chouseenumerated.js';
import config from '../../config/config';

const CompanyNameSearch = ({ onChange, text= '', value = '', displaytext,refresh }) => {
    const [initvalue, setInitValue] = useState('')
    const [inittext, setInitText] = useState('')
    const [initdisplaytext, setInitDisplayText] = useState('')
    const [strefresh,setRefresh] = useState(new Date().getTime())

    // Get auth token from Redux, fallback to external API token
    const authToken = useSelector((state) => state.auth.token);
    const token = authToken || config.EXTERNAL_API_TOKEN;

    useEffect(()=>{
        if(refresh > strefresh)
            setRefresh(refresh)
        if((value??"") > "" && (initvalue !== value))
            setInitValue(value)
        if((text??"") > "" && (inittext !== text))
            setInitText(text)
        if((displaytext??"") > "" && (initdisplaytext !== displaytext)) {
            setInitDisplayText(displaytext)
        }

    },[strefresh,refresh,value,initvalue, text,inittext,displaytext,initdisplaytext, setInitDisplayText,  setInitText,setInitValue, setRefresh])
    const handleSearch = async (query) => {
        if (!query) return [];


        try {
            const response = await fetch(`${config.API_BASE_URL}${config.endpoints.companies.search}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ companyname: query })
            });
            if(response.ok) {
            const data = await response.json();
            if (data.status && Array.isArray(data.data.items)) {
                const items = data.data.items.map((company,index) => ({
                dropdown: `<span key='span_${index}_cnum' style='font-size: 10pt;'>${company.title} (${company.company_number})<br/>${chtypes.company_status[company.company_status] ?? 'Unknown'}</span><br/><span style='font-size: 8pt; color: green;' >${company.address_snippet ?? ''}</span><hr/>`,
                displaytext: `${company.title} (${company.company_number})`,
                value: company.company_number,
                text: company.title,
                registered_address: company.address??{}
                }));
                return items;
            }
            }
        } catch (error) {
            console.error('Fetch error:', error);
        }
        return [];
    };

  return (
    <>
        <SearchBar
        key='cname_key'
        type="company_name"
        placeholder="Search Companies by Name..."
        fetchResults={handleSearch}
        returnValueOnSearch={true}
        fetchOnInput={false}
        showLoadingIcon={true}
        name="companyId"
        onChange={onChange}
        styleOverrides={{input:{fontSize: '10pt'}}}
        value={initvalue}
        text={inittext}
        displaytext={initdisplaytext}
        refresh={refresh}
        />
    </>
  );
};

export default CompanyNameSearch;

